import { useState } from "react";
import { CatalogBuilder } from "../../../../commonGroupModuleStructure/catalogBuilder";
import { MuiRightDrawer } from "../../../../components";
import CheckListSearch from "../../../../components/CheckListSearch";
import { APIParams, deleteRoleUserMapping, getRoleNotInUsers, getRoleUserMapping, updateRoleUserMapping } from "../apiCall";
import { RoleKeys } from "../entity";

export const RoleUserMapping = (props: any) => {
  const { request } = props;
  const [open, setOpen] = useState(false);

  const onClose = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(false);
  }

  const listOfUserDetails = [
    {
      field: "LoginName",
      headerName: "Name",
      editable: false,
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    {
      field: "MobileNumber",
      headerName: "Mobile Number",
      editable: false,
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    {
      field: "Email",
      headerName: "Email",
      editable: false,
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
  ];

  return (
    <>
      <CatalogBuilder
        isHeader={false}
        isRightMenu={true}
        isAssociationButton={true}

        getPagingData={getRoleUserMapping}
        pagingAPIrequest={request}
        pagingAPIKey={RoleKeys.getUserMapping}

        onDelete={deleteRoleUserMapping}
        deletePagingAPIKey={RoleKeys.deleteUserMapping}

        visibleColumns={{
          RoleName: false
        }}
        onClickPlus={() => { setOpen(true) }}
        disableEditAction={true}
        disableViewAction={true}
      />

      <MuiRightDrawer open={open} onClose={onClose} width='40%'>
        <CheckListSearch
          getOptions={async (params: APIParams) => await getRoleNotInUsers({ ...params, request: { ...params.request, ...request } })}
          displayExpr={'LoginName'}
          listKey={RoleKeys.notInUsers}
          label='Add Users'
          name='IdentityId'
          onSubmit={async (params: APIParams) => await updateRoleUserMapping({ ...params, request: { ...params.request, ...request } })}
          onClose={onClose}
          pagingAPIKey={RoleKeys.getUserMapping}
          filterMode='server'
        />
      </MuiRightDrawer>
    </>
  );
};
